import { Globe01, Heading01, Image01, LinkExternal01, Menu01 } from '@untitled-ui/icons-react';
import classNames from 'classnames';
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { ModalPayload } from 'src/contexts/message';

type Props = {
    iframePath: string;
};

export const FullPageDemo = ({ iframePath }: Props) => {
    const isIframe = useMemo(() => {
        try {
            return window.self !== window.top;
        } catch {
            return true;
        }
    }, []);

    const [iframeHeight, setIframeHeight] = useState<number>(200);

    const messageCallback = useCallback((e: MessageEvent) => {
        if (
            typeof e.data === 'object' &&
            e.data.source === 'myhealth-booking-ui' &&
            typeof e.data.payload === 'object'
        ) {
            console.log(e.data);
            const typedData = e.data.payload as ModalPayload;
            if (typedData.message === 'myhealth-booking-ui-widget-resize') {
                setIframeHeight(e.data.payload.value || 200);
            }
            if (typedData.message === 'myhealth-booking-ui-launch') {
                window.open(`${typedData.value}`, '_blank');
            }
        }
    }, []);

    useEffect(() => {
        window.addEventListener('message', messageCallback);
        return () => {
            window.removeEventListener('message', messageCallback);
        };
    }, [messageCallback]);

    if (!isIframe) {
        return (
            <div className="">
                <header className="sticky top-0 border-b bg-white shadow">
                    <div className="container flex h-16 flex-row items-center justify-between">
                        <Heading01 className="text-primary size-6" />
                        <Menu01 className="size-6 text-gray-900" />
                    </div>
                </header>
                <main>
                    {iframePath && (
                        <iframe
                            src={iframePath}
                            className={classNames('w-full transition-all duration-300')}
                            title="inner-display"
                            height={iframeHeight}
                        />
                    )}
                </main>
                <footer className="bg-gray-50 py-12">
                    <div className="container flex flex-row gap-8">
                        <div className="prose-sm text-gray-600">
                            <p>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus aliquid eveniet harum ab
                                quae odio mollitia repellat quos nisi alias. Reprehenderit, voluptate nam expedita aut
                                odio amet omnis impedit assumenda!
                            </p>
                        </div>
                        <div className="flex flex-row items-start gap-2">
                            <Image01 className="size-5" />
                            <Globe01 className="size-5" />
                            <LinkExternal01 className="size-5" />
                        </div>
                    </div>
                </footer>
            </div>
        );
    }

    return <></>;
};
